import { render, staticRenderFns } from "./share-user-stat.vue?vue&type=template&id=032b9c44&scoped=true&"
import script from "./share-user-stat.vue?vue&type=script&lang=js&"
export * from "./share-user-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b9c44",
  null
  
)

export default component.exports